import {EventsPage} from '@features/shift-events'
import {useParams} from 'react-router'

export const CockpitEventsPage = () => {
  const {plantId} = useParams<{plantId: string}>()
  if (!plantId) {
    throw new Error('plantId is required in route params for EventsPage')
  }
  return <EventsPage plantId={plantId} inverted />
}
